import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';

import './chatListBoxShimmerComponent.css';

const ChatListBoxShimmerComponent = () => {
  return (
    <div className="et-v2-chat-list-box-shimmer-container">
      <div className="et-v2-search-shimmer-wrap">
        <ShimmerComponent />
      </div>
      <div className="et-v2-chat-list-row-header-cells-wrap">
        {Array.from({length: 5}).map((val, idx) => (
          <div key={idx} className="et-v2-chat-list-row-header-cell">
            <ShimmerComponent />
          </div>
        ))}
      </div>
      <div className="et-v2-chat-list-rows-wrap">
        {Array.from({length: 10}).map((val, idx) => (
          <div key={idx} className="et-v2-chat-list-row-wrap">
            <ShimmerComponent />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatListBoxShimmerComponent;
